<template>
  <div class="ladder container">
    <nav class="ladder__head">
      <Logo />
      <router-link to="/add" class="tf-button tf-button--narrow">
        Add summoner
      </router-link>
    </nav>
    <h1 class="ladder__h1">Country Rankings</h1>
    <p class="description">
      Country rankings are based on the <a href="https://en.wikipedia.org/wiki/Median" target="_blank">median</a> rank, and are shown for any country that has more than 50 registered summoner.
    </p>
    <table
      v-if="this.countries.length"
      class="data-table"
    >
      <thead>
        <tr class="data-table__row data-table__head">
          <th>#</th>
          <th><b>Country</b></th>
          <th>Median Rank</th>
        </tr>
      </thead>
      <tbody>
        <template
          v-for="(country, index) of countries"
        >
          <tr
            :key="country.country"
            :class="`rank-${index+1}`"
            class="data-table__row country"
          >
            <td class="country__rank">{{ index + 1 }}</td>
            <td class="country__name"><b>{{ country.country }}</b></td>
            <td class="country__highest-rank">
              <span :class="country.medianSummoner.tier" />
              {{ country.medianSummoner.tier }}
              {{ country.medianSummoner.rank }} -
              {{ country.medianSummoner.leaguePoints }} LP
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <Loader v-else />
    <p class="ladder__text">
      Country rankings are updated every 12 hours
    </p>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'
import Loader from '@/components/Loader.vue'
import { db } from '@/main'
import { servers } from '../constants'

export default {
  name: 'CountryRankings',

  components: {
    Logo,
    Loader
  },

  computed: {
    minutesLeft() {
      const date = new Date()
      const minutes = date.getMinutes()
      return 60 - minutes
    }
  },

  data() {
    return {
      countries: [],
      scoreTier: [
        { name: 'CHALLENGER',score: 90},
        { name: 'GRANDMASTER', score: 80},
        { name: 'MASTER', score: 70},
        { name: 'DIAMOND', score: 60},
        { name: 'PLATINUM', score: 50},
        { name: 'GOLD', score: 40},
        { name: 'SILVER', score: 30},
        { name: 'BRONZE', score: 20},
        { name: 'IRON', score: 10}
      ],
      scoreRank: {
        I: 5,
        II: 4,
        III: 3,
        IV: 2
      }
    }
  },

  async created() {
    const countriesSnapshot = await db.collection('stats').doc('all-stats').get()
    const data = countriesSnapshot.data()
    this.countries = data.countries.filter(country => country.count > 50 && country.medianSummoner && country.medianSummoner.tier)
  },

  methods: {

    serverName(serverId) {
      const server = servers.find(server => server.value === serverId)

      return server ? server.name : serverId
    }
  }
}
</script>

<style scoped lang="scss">
.ladder {
  &__head {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__h1 {
    margin: 20px 0;
  }

  &__text {
    text-align: center;
    margin: 40px 0 10px;
    font-size: 14px;
    color: #666;
  }
}

.country {
  &:hover {
    background-color: #ddd;
  }

  &__count {
    font-size: 13px;
    text-align: center;
  }

  &__name {
    flex: 0 0 calc(100% - 45px);
  }

  @media (max-width: 900px) {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #ddd;
  }
}

@media (max-width: 900px) {
  .data-table__head {
    display: none;
  }
}

.description {
  margin-bottom: 30px;
  font-size: 18px;

  a {
    border-bottom: 1px dashed currentColor;
  }
}
</style>